import { Stack } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";

import useStackListAnalytics from "../../useStackListAnalytics";

const StacksTableNameCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  const trackAnalytics = useStackListAnalytics();

  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={`/stack/${stack.id}`} onPress={() => trackAnalytics("Link clicked")}>
        {stack.name}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default StacksTableNameCell;
